import { getHighestNumber } from '@afterpay/utils'
import { CashEligibilitySignals } from '@afterpaytouch/portal-api/consumer/lookup'
import { OrderSource } from '@afterpaytouch/portal-api'
import { ActionMobilesLookupResponse } from '@afterpay/verify-service-api'

export interface InitialiseLookup {
  cashtag?: string | null
  existing: boolean
  shadowAccountExists?: boolean
  email?: string
  merchantId: number
  cashEligibilitySignals?: CashEligibilitySignals | null
  cashCreationDate?: number
  merchantOrderSource?: OrderSource
}

const mergeCashEligibilitySignals = (
  emailSignals?: CashEligibilitySignals | null,
  mobileSignals?: CashEligibilitySignals | null
): CashEligibilitySignals | null | undefined => {
  if (emailSignals === null || emailSignals === undefined) {
    return mobileSignals
  }

  return {
    hasEmail: (emailSignals?.hasEmail || mobileSignals?.hasEmail) ?? false,

    hasSmsNumber: (emailSignals?.hasSmsNumber || mobileSignals?.hasSmsNumber) ?? false,

    hasVerifiedIdentity: (emailSignals?.hasVerifiedIdentity || mobileSignals?.hasVerifiedIdentity) ?? false,

    hasLinkedDebit: (emailSignals?.hasLinkedDebit || mobileSignals?.hasLinkedDebit) ?? false,

    hasValidRegion: (emailSignals?.hasValidRegion || mobileSignals?.hasValidRegion) ?? false,
    mostRecentActivityAt: getHighestNumber([emailSignals?.mostRecentActivityAt, mobileSignals?.mostRecentActivityAt]),
  }
}

export const deepMergeLookupResponse = (emailLookup: InitialiseLookup, mobileLookup: ActionMobilesLookupResponse): InitialiseLookup => {
  const initialiseMobileLookupResponse = {
    cashtag: emailLookup.cashtag ?? mobileLookup.cashtag,
    existing: emailLookup.existing || mobileLookup.existing,

    shadowAccountExists: emailLookup.shadowAccountExists || mobileLookup.shadowAccountExists,
    cashEligibilitySignals: mergeCashEligibilitySignals(emailLookup.cashEligibilitySignals, mobileLookup.cashEligibilitySignals),
    cashCreationDate: emailLookup.cashCreationDate ?? mobileLookup.creationDate,
  }

  return {
    ...emailLookup,
    ...initialiseMobileLookupResponse,
  }
}
